import { useEffect, useState } from "react";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { Skeleton } from "@/components/Shared";
import { Badge } from "@/components/ui/badge";

export default function Prices() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dashboard/prices").then(({ data }) => setData(data));
  }, []);

  if (!data) return <Skeleton className="h-96" />;

  return (
    <div className="space-y-6" data-testid="prices-page">
      <p className="text-sm text-muted-foreground">
        Realized selling prices per SKU on Amazon.in over the last 90 days (from actual orders). Flipkart and Website columns will appear here once those channels connect.
      </p>
      {data.items.length === 0 ? (
        <p className="p-6 text-sm text-muted-foreground bg-card border border-border rounded-lg">No item-level price data yet — appears as the order-items sync progresses.</p>
      ) : (
        <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden" data-testid="prices-table">
          <table className="w-full text-sm">
            <thead className="bg-muted/60 text-xs uppercase tracking-wider text-muted-foreground">
              <tr>
                {["Product", "SKU", "Units Sold", "Avg Price", "Min", "Max", "Spread"].map((h) => (
                  <th key={h} className="text-left px-4 py-3 font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.items.map((p) => (
                <tr key={p.sku} className="border-t border-border hover:bg-muted/40 transition-colors" data-testid={`price-row-${p.sku}`}>
                  <td className="px-4 py-2.5 font-medium max-w-md truncate">{p.name || p.sku}</td>
                  <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground">{p.sku}</td>
                  <td className="px-4 py-2.5">{p.units}</td>
                  <td className="px-4 py-2.5 font-semibold">{inr(p.avg_price)}</td>
                  <td className="px-4 py-2.5 text-green-600">{inr(p.min_price)}</td>
                  <td className="px-4 py-2.5 text-red-600">{inr(p.max_price)}</td>
                  <td className="px-4 py-2.5">
                    <Badge className={`border-0 font-semibold ${p.spread > 0 ? "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400" : "bg-muted text-muted-foreground"}`}>
                      {inr(p.spread)}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
